import { Col, Container, Form, FormCheck, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLoaderData, useNavigate } from "react-router-dom";
import SelectionWithPath from "../../components/SelectionPath";
import { templateNavigationLevels, TemplateNavigationPath, TemplatesFilter } from "../../models/templates";
import { useAppSelector } from "../../store";
import { templatesActions } from "../../store/templates-slice";

function TemplateSelection({
  createNew,
  setCreateNew,
}: {
  createNew: boolean;
  setCreateNew: (value: boolean) => void;
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedPath = useAppSelector((state) => state.templates.selectedPath);
  const selectedVersion = useAppSelector((state) => state.templates.selectedVersion);
  const filter = useAppSelector((state) => state.templates.filter);

  const { availableOptions } = useLoaderData();

  const setFilter = (filter: TemplatesFilter) => {
    dispatch(templatesActions.setFilter(filter));
    navigate(location.pathname);
  };

  const selectNewPath = (level: string, value: string) => {
    let newSelectedPath: TemplateNavigationPath = {};
    for (const l of templateNavigationLevels) {
      if (l === level) break;
      newSelectedPath[l] = selectedPath![l];
    }
    newSelectedPath[level] = value;
    navigate(`/templates/${newSelectedPath.namespace}/${newSelectedPath.category}/${newSelectedPath.name}/draft`);
  };

  if (!selectedPath) return <div></div>;

  return (
    <Container className="automation-filters mb-3 border rounded p-3" style={{ backgroundColor: "#d5d8f0" }}>
      <Form>
        <Row className="mb-3">
          <Col>
            {selectedVersion === "draft" && (
              <>
                You are in <span style={{ fontSize: "2em", fontWeight: "bold" }}>draft</span> mode.{" "}
              </>
            )}
            {selectedVersion === "live" && (
              <>
                You are in viewing the <span style={{ fontSize: "2em", fontWeight: "bold" }}>live</span> version{" "}
                <span style={{ fontSize: "0.6em" }}>(go to draft to edit)</span>.
              </>
            )}
            {selectedVersion !== "draft" && selectedVersion !== "live" && (
              <>
                You are viewing version <span style={{ fontSize: "2em", fontWeight: "bold" }}>{selectedVersion}</span>.
              </>
            )}

            {!createNew && (
              <>
                &nbsp;&nbsp;
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(), setCreateNew(true);
                  }}
                >
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id={`tooltip-bottom`}>Create a new namespace or block.</Tooltip>}
                  >
                    <i className="bi bi-plus-circle"></i>
                  </OverlayTrigger>
                </a>
              </>
            )}
          </Col>
          <Col>
            <Container>
              <Row>
                <Col className="d-flex justify-content-end">
                  <FormCheck
                    id="hasDraftVersion"
                    type="switch"
                    label="Has Draft Version"
                    checked={filter.hasDraftVersion}
                    onChange={() => {
                      setFilter({ ...filter, hasDraftVersion: !filter.hasDraftVersion });
                    }}
                    className="ms-3"
                  ></FormCheck>
                  <FormCheck
                    id="hasLiveVersion"
                    type="switch"
                    label="Has Live Version"
                    checked={filter.hasLiveVersion}
                    onChange={() => {
                      setFilter({ ...filter, hasLiveVersion: !filter.hasLiveVersion });
                    }}
                    className="ms-3"
                  ></FormCheck>
                  <span
                    style={{
                      fontSize: "0.6em",
                      lineHeight: "3em",
                      paddingLeft: "20px",
                      cursor: "pointer",
                      color: "#9b9fc2",
                    }}
                    onClick={() => {
                      dispatch(templatesActions.clearFilter());
                      navigate(location.pathname);
                    }}
                  >
                    reset filters
                  </span>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <SelectionWithPath
          availableOptions={availableOptions}
          levels={templateNavigationLevels}
          currentSelectionPerLevel={selectedPath}
          dropdownChange={selectNewPath}
        />
        {availableOptions.namespace.length === 0 && (
          <Row>
            <div
              className="border rounded px-3 d-flex align-items-center justify-content-center"
              style={{
                padding: "10px",
                height: "75px",
                backgroundColor: "#e4e6f5",
              }}
            >
              <i>Due to filtering, no automations are available. Please adjust your filters.</i>
            </div>
          </Row>
        )}
      </Form>
    </Container>
  );
}

export default TemplateSelection;
